import { getIsModernSsr } from './get-is-modern-ssr.tsx';
import { getStaticFallbackContext } from './static-fallback-context.tsx';

export function getSsrStatus(): 'static' | 'modern' | 'legacy' | 'client' {
	if (__SERVER__) {
		if (getIsModernSsr()) {
			if (getStaticFallbackContext()) {
				return 'static';
			}
			return 'modern';
		}
		return 'legacy';
	}
	return 'client';
}
